import {
  CardStyleInterpolators,
  StackScreenProps,
} from "@react-navigation/stack";
import {
  ActionCreateInvoiceSaleRootParamList,
  ActionsRootParamList,
} from "../../../../types";
import {
  ModalCloseButton,
  createStackHeaderNavigator,
} from "@towersystems/roam-common-native";
import { CustomerRootScreen } from "../CustomerRootScreen";
import { ConfirmInvoiceDetailsScreen } from "../ConfirmInvoiceDetailsScreen";
import {
  CustomerRootScreenActionsContext,
  OnCustomerSelectedFn,
} from "../CustomerRootScreen/context";
import React from "react";
import { useTranslation } from "../../../../utilities/i18n";

export interface ActionCreateInvoiceSaleRootScreenProps
  extends StackScreenProps<
    ActionsRootParamList & ActionCreateInvoiceSaleRootParamList,
    "ActionCreateInvoiceSaleRootScreen"
  > {}

export const ActionCreateInvoiceSaleRootScreen = ({
  navigation,
}: ActionCreateInvoiceSaleRootScreenProps) => {
  const { t } = useTranslation("pos");
  const Stack =
    createStackHeaderNavigator<ActionCreateInvoiceSaleRootParamList>();

  const handleOnCustomerSelectedOrCreated: OnCustomerSelectedFn =
    React.useCallback(async (customerId) => {
      navigation.navigate("ConfirmInvoiceDetailsScreen", {
        customerId,
      });
    }, []);

  return (
    <CustomerRootScreenActionsContext.Provider
      value={{
        onCustomerSelected: handleOnCustomerSelectedOrCreated,
        onAfterCreateCustomer: handleOnCustomerSelectedOrCreated,
        customerListScreenTitle: t("select_retailer_customer"),
        hideNewCustomerButton: true,
        retailerCustAccountOnly: true,
      }}
    >
      <Stack.Navigator
        screenOptions={{
          animationEnabled: true,
        }}
      >
        <Stack.Group
          screenOptions={{
            headerLeft: () => (
              <ModalCloseButton
                onPress={() => navigation.goBack()}
                type="Cancel"
              />
            ),
            cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
          }}
        >
          <Stack.Screen
            options={{
              headerShown: false,
            }}
            name="CustomerRootScreen"
            component={CustomerRootScreen}
          />
          <Stack.Screen
            options={{
              headerShown: true,
            }}
            name="ConfirmInvoiceDetailsScreen"
            component={ConfirmInvoiceDetailsScreen}
          />
        </Stack.Group>
      </Stack.Navigator>
    </CustomerRootScreenActionsContext.Provider>
  );
};
